import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import 'react-quill/dist/quill.snow.css';
import { Button } from '@mui/material';
import './Editor.css';

let ReactQuill = null;
if (typeof window !== 'undefined') {
  ReactQuill = require('react-quill');
}

const quillModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'list', 'bullet',
  'link', 'image',
];

function Editor({onPreviewGenerated}) {
  const [droppedData, setDroppedData] = useState(Array(1).fill([]));
  const [editorText, setEditorText] = useState('');
  const boxesRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');
  const [ImageWidth,SetImageWidth] = useState();
  const quillRef = useRef(null);
  const handleDrop = (e, index) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (!file) return;

    const reader = new FileReader();
    const newData = [...droppedData];
    const rect = e.currentTarget.getBoundingClientRect();
    const posX = e.clientX - rect.left;
    const posY = e.clientY - rect.top;

    if (file.type.startsWith('image/')) {
      const imageUrl = URL.createObjectURL(file);
      newData[index] = [
        ...newData[index],
        { type: 'image', content: imageUrl, x: posX, y: posY },
      ];
      setDroppedData(newData);
    } else {
      reader.onload = (event) => {
        newData[index] = [
          ...newData[index],
          { type: 'text', content: event.target.result, x: posX, y: posY },
        ];
        setDroppedData(newData);
      };
      reader.readAsText(file);
    }
  };


  const handlePaste = (e, index) => {
  e.preventDefault();
  const html = e.clipboardData.getData('text/html');
  const plainText = e.clipboardData.getData('text/plain');
  const newData = [...droppedData];

  newData[index] = [
    ...newData[index],
    {
      type: 'text',
      content: html || plainText,
      x: 10,
      y: 10,
    },
  ];
  setDroppedData(newData);
};


  const makeDraggable = (index, itemIndex) => (e) => {
    const startX = e.clientX;
    const startY = e.clientY;
    const currentItem = droppedData[index][itemIndex];


    const onMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const deltaY = moveEvent.clientY - startY;
      const newData = [...droppedData];
      newData[index][itemIndex] = {
        ...currentItem,
        x: (currentItem.x || 0) + deltaX,
        y: (currentItem.y || 0) + deltaY,
      };
      setDroppedData(newData);
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  const handleExportAsImage = () => {
  if (boxesRef.current) {
     const container = boxesRef.current;
      boxesRef.current.classList.add('withoutborder');
    // Temporarily remove borders for clean export
       const clearButtons = container.querySelectorAll('.clear-Editor-button');
       clearButtons.forEach((btn) => btn.classList.add('hide-on-export'));
       const scale = 5;
    const rect = container.getBoundingClientRect();
     SetImageWidth(rect.width)
      html2canvas(container, {
        width: rect.width,
        height: rect.height,
        scrollX: 0,
        scrollY: 0,
        scale: scale,
      }).then((canvas) => {
        const image = canvas.toDataURL('image/png');
        setPreviewImage(image);
        //call back function
      
      // Restore border after export
         boxesRef.current.classList.remove('withoutborder');
       clearButtons.forEach((btn) => btn.classList.remove('hide-on-export'));
    });
  }
};
const Onsave = () =>{
  if (onPreviewGenerated && previewImage) {
          onPreviewGenerated(previewImage);
        }
}
const handleClearBox = (index) => {
  const newData = [...droppedData];
  newData[index] = [];
  setDroppedData(newData);
};

 const applyTextColor = (color) => {
  if (quillRef.current) {
    const editor = quillRef.current.getEditor();
    editor.format('color', color);
  }
};

  return (
    <>
      <div className="outer-container">
        <div className='common-FontSize-small'>
          <p>
            You can download high-quality medical and health-related icons and images for free from these websites:
            <ul>
              <li>
                <a href="https://fontawesome.com/icons?d=gallery&q=medical" target="_blank" rel="noopener noreferrer">
                  FontAwesome – Medical Icons
                </a>
              </li>
              <li>
                <a href="https://www.flaticon.com/free-icons/medical" target="_blank" rel="noopener noreferrer">
                  Flaticon – Medical Icons
                </a>
              </li>
            </ul>
          </p>
        </div>

         <span className='common-Font-10'>
            Feel free to paste or drag & drop your content here.
          </span>
        <div className="grid-container"   style={{ backgroundColor: backgroundColor }}>
          {droppedData.map((items, i) => (
            <div
              key={i}
              className="section"
              onDrop={(e) => handleDrop(e, i)}
              onDragOver={(e) => e.preventDefault()}
              onPaste={(e) => handlePaste(e, i)}
              style={{ position: 'relative' }}
              ref={boxesRef}
            >
              {/* Clear Button */}
              <button className='clear-Editor-button' onClick={() => handleClearBox(i)}>
                Clear
              </button>


              {items.map((item, idx) => (
                <div
                  key={idx}
                  onMouseDown={makeDraggable(i, idx)}
                  style={{
                    position: 'absolute',
                    left: item.x || 0,
                    top: item.y || 0,
                    cursor: 'move',
                  }}
                >
                  {item.type === 'image' ? (
                    <img
                      src={item.content}
                      alt="Dropped"
                      style={{ maxWidth: '100px', maxHeight: '100px' }}
                    />
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                  )}
                </div>
              ))}
            </div>
          ))}

        </div>

        {/* Export Button */}
        <div style={{ marginTop: '10px' , display:'flex'}} >
          <Button onClick={handleExportAsImage} variant="contained" type='button' className='common-button' >
            Review Output as Image
          </Button>
            <Button onClick={Onsave} variant="contained" type='button'  className='common-button'>
            Save
          </Button>
        </div>

        {/* Display Image */}
        {previewImage && (
          <div style={{ marginTop: '10px',width: ImageWidth,border:"1px dashed"}}>
            {/* <span>Output Preview</span> */}
            <img src={previewImage} alt="Output Preview" style={{ width: ImageWidth }} />
          </div>
        )}
        {ReactQuill && (
          <div style={{ marginTop: '40px' }}>
            <span>Text Editor (Rich formatting with color)</span>

            <div style={{ display: 'flex', gap: '20px', marginBottom: '10px', alignItems: 'center' }}>
              <div>
                <label>Text Color:</label>
                <input type="color" onChange={(e) => applyTextColor(e.target.value)} />
              </div>
              {/* <div>
                <label>Background Color:</label>
                <input
                  type="color"
                  value={backgroundColor}
                  onChange={(e) => setBackgroundColor(e.target.value)}
                />
              </div> */}
            </div>

            <ReactQuill
              ref={quillRef}
              value={editorText}
              onChange={setEditorText}
              theme="snow"
              modules={quillModules}
              formats={quillFormats}
              style={{ height: '200px', marginBottom: '20px' }}
            />
          </div>
        )}
      </div>

    </>
  );
}

export default Editor;
